var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('container',[_c('div',{staticClass:"logo"},[_c('sprite',{attrs:{"name":"logoBlasts","width":"300"}})],1),_vm._v(" "),_c('div',{attrs:{"role":"alert"}},[_c('h1',[_vm._v("You have been logged off.")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":""},on:{"click":function($event){_vm.close()}}},[_vm._v("Please close this window or tab")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57603def","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/logout/index.vue
// module id = null
// module chunks = 